var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list-unstyled"},_vm._l((_vm.exHighlights),function(item,i){return _c('li',{key:`highlights-${i}`},[_c('i',{staticClass:"el-icon-arrow-right"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }